import React, { useMemo } from "react";
import { Card, Row, Col, Table, Statistic, Tag } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line, Legend } from "recharts";
import Dashboard from "./components/Dashboard";

import DashboardLayout from "./components/bdedetails/DashboardLayout";
import LeadsPerformance from "./components/bdedetails/LeadsPerformance";
import BdePipeline from "./components/bde/BdePipeline";
import SalesMetricsView from "./components/bdedetails/SalesMetricsView";
import DashboardSection from "./components/bdedetails/DashboardSection";
import CurrentOpenings from "../../../Jobs/index"
import DealFinancialTable from "./components/bdedetails/DealFinancialTable";
import ProjectOverviewTable from "./components/bdedetails/ProjectOverviewTable";
import DeveloperDeploymentTable from "./components/bdedetails/DeveloperDeploymentTable";




const COLORS = ["#00C49F", "#FF8042"];

const BDEDetails = () => {




    return (
        <div className="">
            <DashboardLayout />
            <LeadsPerformance />
            <BdePipeline />
            <SalesMetricsView />
            <DashboardSection />
            <DealFinancialTable />
            <ProjectOverviewTable />
            <DeveloperDeploymentTable />
          




        </div>
    );
};

export default BDEDetails;
